import { categories } from "@/mocks/categories";
import type { Category } from "@/mocks/categories";

export interface CatalogSeller {
  full_name: string | null;
  username: string | null;
  avatar_url: string | null;
  whatsapp: string | null;
}

export interface CategoryProduct {
  id: number;
  seller_id: string;
  title: string;
  description: string | null;
  price: number | string;
  category: string;
  condition: string | null;
  images: string[] | null;
  status: string;
  currency: string | null;
  views: number | null;
  featured: boolean | null;
  created_at: string;
  profiles: CatalogSeller | null;
}

export type SortKey = "recent" | "price-asc" | "price-desc";

export function getCategoryBySlug(slug?: string): Category | undefined {
  if (!slug) return undefined;
  return categories.find((cat) => cat.id === slug);
}

export function formatPrice(
  value: number | string | null | undefined,
  currency?: string | null,
): string {
  const amount = Number(value ?? 0);
  const prefix = currency === "USD" ? "US$" : "RD$";
  return `${prefix}${amount.toLocaleString("es-DO")}`;
}

export function conditionLabel(condition: string | null | undefined): string {
  if (!condition) return "Sin especificar";
  return condition.toLowerCase() === "nuevo" ? "Nuevo" : "Usado";
}

export function timeAgo(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const diff = Date.now() - then;
  const minutes = Math.floor(diff / 60000);
  if (minutes < 60) return `Hace ${Math.max(minutes, 1)} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `Hace ${hours} h`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `Hace ${days} d`;
  const months = Math.floor(days / 30);
  return `Hace ${months} mes${months > 1 ? "es" : ""}`;
}

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Indica si una publicación es "reciente" (dentro de los últimos N días).
 * Se usa para mostrar la etiqueta "Nuevo" de forma automática y que
 * desaparezca sola pasados 15 días desde su creación.
 */
export function isRecent(
  iso: string | null | undefined,
  days = 15,
): boolean {
  if (!iso) return false;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return false;
  const diff = Date.now() - then;
  return diff >= 0 && diff < days * DAY_MS;
}